/**
 * JS Implementation of MurmurHash3 (r136)
 * 
 * https://www.npmjs.com/package/murmurhash-js
 * https://github.com/mikolalysenko/murmurhash-js/blob/master/murmurhash3_gc.js
 * 
 * @param {string} key ASCII only
 * @return {number} 32-bit positive integer hash 
 */
function murmurhash3_32_gc(key) {
	var remainder, bytes, h1, h1b, c1, c1b, c2, c2b, k1, i;
	
	remainder = key.length & 3; // key.length % 4
	bytes = key.length - remainder;
	h1 = 0;
	c1 = 0xcc9e2d51;
	c2 = 0x1b873593;
	i = 0;
	
	while (i < bytes) {
	  	k1 = 
	  	  ((key.charCodeAt(i) & 0xff)) |
	  	  ((key.charCodeAt(++i) & 0xff) << 8) |
	  	  ((key.charCodeAt(++i) & 0xff) << 16) |
	  	  ((key.charCodeAt(++i) & 0xff) << 24);
		++i;
		
		k1 = ((((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16))) & 0xffffffff;
		k1 = (k1 << 15) | (k1 >>> 17);
		k1 = ((((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16))) & 0xffffffff;

		h1 ^= k1;
        h1 = (h1 << 13) | (h1 >>> 19);
		h1b = ((((h1 & 0xffff) * 5) + ((((h1 >>> 16) * 5) & 0xffff) << 16))) & 0xffffffff;
		h1 = (((h1b & 0xffff) + 0x6b64) + ((((h1b >>> 16) + 0xe654) & 0xffff) << 16));
	}
	
	k1 = 0;
	
	switch (remainder) {
		case 3: k1 ^= (key.charCodeAt(i + 2) & 0xff) << 16;
		case 2: k1 ^= (key.charCodeAt(i + 1) & 0xff) << 8;
		case 1: k1 ^= (key.charCodeAt(i) & 0xff);
		
		k1 = (((k1 & 0xffff) * c1) + ((((k1 >>> 16) * c1) & 0xffff) << 16)) & 0xffffffff;
		k1 = (k1 << 15) | (k1 >>> 17);
		k1 = (((k1 & 0xffff) * c2) + ((((k1 >>> 16) * c2) & 0xffff) << 16)) & 0xffffffff;
		h1 ^= k1;
	}
	
	h1 ^= key.length;

	h1 ^= h1 >>> 16;
	h1 = (((h1 & 0xffff) * 0x85ebca6b) + ((((h1 >>> 16) * 0x85ebca6b) & 0xffff) << 16)) & 0xffffffff;
	h1 ^= h1 >>> 13;
	h1 = ((((h1 & 0xffff) * 0xc2b2ae35) + ((((h1 >>> 16) * 0xc2b2ae35) & 0xffff) << 16))) & 0xffffffff;
	h1 ^= h1 >>> 16;

	return h1 >>> 0;
}

function calculateExperimentGroup() {
  const anonymousId = analytics.user().anonymousId();
  const bucket = murmurhash3_32_gc(`${experimentName}:${anonymousId}`) % 100;
  const group = bucket < 30 ? "variant" : "control"; // 30% variant, 70% control
  return group;
}

function getPageType() {
	if (window.dotPageType) return window.dotPageType;
	const path = window.location.pathname.replace(/\/+$/, "") || "/";
	if (path === "/") return "index";
	if (/\/products\/[^/]+$/.test(path)) return "product";
	if (path === "/collections") return "list-collections";
	if (path.startsWith("/collections/")) {
		return /\/products\//.test(path) ? "product" : "collection";
	}
	return "";
}

function isEligibleExperimentPage() {
	return ELIGIBLE_PAGE_TYPES.includes(getPageType());
}

function hasExperimentStarted() {
	return !!localStorage.getItem(startedKey);
}

function calculateExperimentGroupByParam() {
	const urlParams = new URLSearchParams(window.location.search);
	const expParam = urlParams.get("dc_exp");
	if (expParam === VARIANT_PARAM) {
		return "variant";
	}
	return localStorage.getItem(groupKey) === "variant" ? "variant" : "control";
}

document.addEventListener("DOMContentLoaded", function() {
	function updateUI() {
		const template = document.getElementById('trial-checkbox-template');
		if (template) {
			const clone = template.content.cloneNode(true);
			template.replaceWith(clone);
		}
		const templateOptIn = document.querySelectorAll('.trial-opt-in-template');
		for (const t of templateOptIn) {
			const clone = t.content.cloneNode(true);
			t.replaceWith(clone);
		}
		const templateOptInMobile = document.querySelectorAll('.trial-opt-in-template-mobile');
		for (const t of templateOptInMobile) {
			const clone = t.content.cloneNode(true);
			t.replaceWith(clone);
		}
	}

	function persistVariantAssignment() {
		localStorage.setItem(groupKey, "variant");
	}

	function trackExperimentStarted() {
		if (hasExperimentStarted()) return;
		if (!isEligibleExperimentPage()) return;
		analytics.track("Experiment Started", {
			experiment_name: experimentName,
			experiment_group: "variant",
			experiment_version: experimentVersion
		});
		localStorage.setItem(startedKey, "true");
	}

	function applyVariant() {
		persistVariantAssignment();
		updateUI();
		trackExperimentStarted();
	}

	function applyVariantOnLoad() {
		if (window.analytics) {
			applyVariant();
		} else {
			persistVariantAssignment();
			updateUI();
			const checkAnalytics = setInterval(() => {
				if (window.analytics) {
					trackExperimentStarted();
					clearInterval(checkAnalytics);
				}
			}, 500);
		}
	}

	const previouslyAssigned = localStorage.getItem(groupKey) === "variant";
	if (previouslyAssigned && !hasExperimentStarted()) {
		localStorage.setItem(startedKey, "true");
	}

	const group = calculateExperimentGroupByParam();
	if (group === "variant") {
		applyVariantOnLoad();
	}
});
